import React from 'react';
import { Button } from '../ui/Button';
export function Hero() {
  return <div className="relative min-h-screen flex items-center justify-center overflow-hidden pt-20" data-id="element-204">
      {/* Video Background */}
      <div className="absolute inset-0 z-0" data-id="element-205">
        <div className="absolute inset-0 bg-black/30 z-10" data-id="element-206"></div>
        <video className="w-full h-full object-cover" autoPlay loop muted playsInline poster="https://images.unsplash.com/photo-1506929562872-bb421503ef21?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2068&q=80" data-id="element-207">
          <source src="https://player.vimeo.com/external/370331493.sd.mp4?s=e90dcaba73c19e0e36f03406b47bbd6992dd6c1c&profile_id=139&oauth2_token_id=57447761" type="video/mp4" data-id="element-208" />
          Your browser does not support the video tag.
        </video>
      </div>
      {/* Content - Centered */}
      <div className="container mx-auto px-4 md:px-6 relative z-10" data-id="element-209">
        <div className="max-w-4xl mx-auto text-center text-white" data-id="element-210">
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold mb-4" data-id="element-211">
            Bringing your Boardroom
            <span className="block text-[#FF6B65]" data-id="element-212">to the Beach</span>
          </h1>
          <p className="text-lg md:text-xl mb-8 text-white/90 max-w-2xl mx-auto" data-id="element-213">
            Transform meetings into once-in-a-lifetime moments where ideas spark
            under palm trees and strategy sessions end with sunset toes-in-sand.
          </p>
          <div className="flex justify-center" data-id="element-214">
            <Button variant="primary" size="lg" to="/contact" data-id="element-215">
              Book a Discovery Call
            </Button>
          </div>
        </div>
      </div>
      {/* Scroll indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 z-10 animate-bounce" data-id="element-216">
        <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-217">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 14l-7 7m0 0l-7-7m7 7V3" data-id="element-218" />
        </svg>
      </div>
    </div>;
}